// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1CardFinderRequestSearchDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1CardFinderRequestSearchDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1CardFinderRequestSearchDefaultResponse.discriminator = undefined;
PharmacyV1CardFinderRequestSearchDefaultResponse.additionalProperties = false;
PharmacyV1CardFinderRequestSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1CardFinderRequestSearchDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1CardFinderRequestSearchDefaultResponse.js.map